import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import JaPage from "../views/JaPage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
  },
  {
    path: "/ja",
    name: "ja",
    component: JaPage,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
